import { Component, Input } from '@angular/core'
import { ICustomTableColumn } from '../../modals/interface/custom-table.interface'
import { CustomTableColumnType } from '../../modals/enum/custom-table.enum'

@Component({
    selector: 'app-default-row',
    templateUrl: './default-row.component.html',
    styleUrls: ['./default-row.component.scss'],
    standalone: false
})
export class DefaultRowComponent {
  @Input() uid: string
  @Input() row: any
  @Input() columns: ICustomTableColumn[]

  public get EnumColumnType(): typeof CustomTableColumnType {
    return CustomTableColumnType
  }
}
